<div class="detail-page-card">
    <div class="detail-page-card-title">
        Working days
        <cerrix-instructions-icon
            [instructionText]="
                'The selected working days can be used in planning of series of activities based on working days, in combination with the holidays and days off'
            "
            [showText]="false"
        ></cerrix-instructions-icon>
    </div>
    <div class="detail-page-card-body padded form-group-styling cerrix-control-sm">
        @if (isLoaded) {
            <div class="list-title">Select working days of the week</div>
            <div class="week-list">
                @for (day of workingDaysList; track day.shortName) {
                    <cerrix-checkbox
                        class="modern"
                        [label]="day.name"
                        [(value)]="day.isSelected"
                        (click)="onToggle()"
                    ></cerrix-checkbox>
                }
            </div>
        } @else {
            <div class="fancy-loader submodule"></div>
        }
    </div>
</div>
